import React from 'react';
import { createSvgIcon } from '@mui/material';

export default createSvgIcon(
  <>
    <path d="m 22.999999,14.381788 v 8.134999 h -4.716035 v -7.589971 c 0,-1.906792 -0.682499,-3.208715 -2.388746,-3.208715 a 2.5876737,2.5876737 0 0 0 -2.425944,1.725655 3.2345921,3.2345921 0 0 0 -0.16173,1.149897 v 7.924751 H 8.5963611 c 0,0 0.06307,-12.8558859 0,-14.1885379 h 4.7208869 v 2.0102989 l -0.03073,0.04528 h 0.03073 v -0.04528 a 4.6901585,4.6901585 0 0 1 4.251871,-2.3450789 c 3.105209,0.0016 5.43088,2.0297059 5.43088,6.3867019 z M 3.6652251,1.490321 a 2.45829,2.45829 0 1 0 -0.06307,4.9036416 h 0.03073 a 2.4599073,2.4599073 0 1 0 0.03073,-4.9036416 z m -2.390363,21.024848 h 4.716035 V 8.3298661 h -4.716035 z" />
  </>,
  'LinkedinLight',
);
